import styled from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { CONTAINER_MAX } from '@/constants/breakpoints';
import {
  containerPaddingInline,
  flexCenterAligned,
  flexColumn,
  openingEffect
} from '@/styles/common';

export const BurgerButton = styled.button`
  ${flexCenterAligned};
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px;
  width: 42px;
  height: 40px;
  border-radius: 50%;
  margin-left: -10px;

  svg {
    width: 22px;
    height: 14px;
    color: var(--textAndLabels-main);
  }

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    display: none;
  }
`;

export const Content = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: calc(var(--banner-header-offset, 0px) + 75px);
  left: 0;
  width: 100%;
  border-top: 1px solid var(--border-main);
  background: var(--bg-main);
  z-index: 3;
  display: flex;
  justify-content: space-between;
  padding-block: 40px;
  ${containerPaddingInline};
  ${openingEffect()}
  color:var(--textAndLabels-main);
`;

export const MenuLinksWrapper = styled.div`
  ${flexColumn};
  gap: 25px;
`;

export const MenuLink = styled(Typography).attrs({ variant: 'body1' })`
  transition: color 0.3s ease;

  &:hover {
    color: var(--custom-yellow);
  }
`;

export const ContactsAndLanguageWrapper = styled.div`
  ${flexColumn};
  justify-content: space-between;
`;

export const ContactsWrapper = styled.div`
  ${flexColumn};
  align-items: flex-end;
`;

export const ContactsTitle = styled(Typography).attrs({ variant: 'body1' })`
  margin-bottom: 10px;
  color: var(--textAndLabels-tertiary);
`;

export const Contacts = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
`;

export const BurgerOverlay = styled.div`
  position: fixed;
  top: calc(var(--banner-header-offset, 0px) + 75px);
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 3;
`;
